export default __webpack_public_path__ + "static/media/platform.ce9a0611.webp";